import { useContext, useState, useEffect } from 'react';
import ConfigurationContext from '../Contexts/ConfigurationContext';
import { UserPreferencesContext } from '../Contexts/UserPreferencesContext';

const useLocale = () => {
    const { configurationData } = useContext(ConfigurationContext);
    const { userPreferences } = useContext(UserPreferencesContext);
    const [localeCode, setLocaleCode] = useState();

    useEffect(() => {
        if (userPreferences && userPreferences.locale && userPreferences.locale !== "" && localeCode !== userPreferences.locale) {
            setLocaleCode(userPreferences.locale);
        }
        else if (configurationData) {

            var localeConfigItem = configurationData?.find(element => element.name === "Locale");

            if (localeConfigItem && localeCode !== localeConfigItem.value) {
                setLocaleCode(localeConfigItem.value);
            }
        }
    }, [configurationData, userPreferences]);

    return localeCode;
}

export default useLocale